export interface Props {
  phone: string;
  isOpen: boolean;
  close: () => void;
  onSuccess: () => void;
  onManualClose?: () => void;
}

export enum EventName {
  Finished = 'authenticationFinished',
  Closed = 'authenticationModalClose',
}

export interface EventData {
  name?: EventName;
  access_token?: string;
}
